import type { DateTime } from 'luxon'

import type { WorldLevel } from '@/queries/constants'

import CompleteTaskModal from '../CompleteTaskModal'
import { Priority, type TodoItem } from '../types'

export type SurveyTodoConfig = {
  title: string
  subtitle: string
  deadline?: DateTime | null
  completed: boolean
  modalDetails: {
    key: string
    title: string
    body?: () => JSX.Element
    link: string
    onMarkComplete: () => Promise<void>
  }
}

export default function buildSurveyTodoItems({
  configs,
  worldSlug,
  targetLevel,
  openModalKey,
  setOpenModalKey,
}: {
  configs: SurveyTodoConfig[]
  worldSlug: string
  targetLevel: Extract<WorldLevel, 'member' | 'tutor'>
  openModalKey: string | null
  setOpenModalKey: (key: string | null) => void
}): TodoItem[] {
  return configs.map(({ title, subtitle, deadline, completed, modalDetails }) => ({
    worldSlug,
    title,
    subtitle,
    priority: Priority.High,
    emoji: '📝',
    onClick: () => setOpenModalKey(modalDetails.key),
    completed,
    deadline,
    showOnSeriesPage: true,
    additionalComponent: () => (
      <CompleteTaskModal
        title={modalDetails.title}
        body={modalDetails.body}
        link={modalDetails.link}
        open={openModalKey === modalDetails.key}
        onClose={() => setOpenModalKey(null)}
        onMarkComplete={modalDetails.onMarkComplete}
      />
    ),
    targetLevel,
  }))
}
